export default __webpack_public_path__ + "static/media/1.031efc0b.jpg";